var name_nivel1_canino = "Canino";
var name_nivel2_canino = "Caninus lupus familiaris"
var name_nivel3_canino = "Perro"

var name_nivel1_felino = "Felino"
var name_nivel2_felino = "Felis catus"
var name_nivel3_felino = "Gato"

var name_nivel1_equino = "Equino"
var name_nivel2_equino = "Equus caballus"
var name_nivel3_equino = "Caballo"

var url_equino = "https://firebasestorage.googleapis.com/v0/b/pixan-cloud.appspot.com/o/Assets%2FEsp_3_equino-.png?alt=media&token=fda643da-2a8e-41e2-ad56-d2da9ebd7e01"
var url_canino = "https://firebasestorage.googleapis.com/v0/b/pixan-cloud.appspot.com/o/Assets%2FEsp_1_canino.png?alt=media&token=21f64c69-cd72-4b2a-99d1-e71ba49578c8"
var url_felino = "https://firebasestorage.googleapis.com/v0/b/pixan-cloud.appspot.com/o/Assets%2FEsp_2_felino.png?alt=media&token=4354109b-4a68-43af-9de7-ec8c5042c345"

export const ESPECIES_BASE_OBJ = {
  ESPECIES: {
    children: [{
        /****************** Anfibio ***************/
        children: [ //Especie
          {},
          {
            children: [ //Nombre cientifico
              {},
              {
                children: [ //Nombre Comun
                  {},
                  { //Raza
                    delete: false,
                    id: 'be00ee8d-a11e-4ce0-a0b0',
                    id_nivel1: 'f49d7370-3c3d-4353-828a',
                    id_nivel2: 'eabc54cb-85e5-4613-a1ff',
                    id_nivel3: '42aa5310-ce5c-4856-8ca0',
                    name: 'Tortuga', //raza
                    name_nivel1: 'Anfibio',
                    name_nivel2: 'Anphibia',
                    name_nivel3: 'Tortuga',
                    nivel: 4,
                  }

                ],
                delete: false,
                id: '42aa5310-ce5c-4856-8ca0',
                id_nivel1: 'f49d7370-3c3d-4353-828a',
                id_nivel2: 'eabc54cb-85e5-4613-a1ff',
                name: 'Tortuga', //nombre_comun
                name_nivel1: 'Anfibio',
                name_nivel2: 'Anphibia',
                no_eliminar: true,
                nivel: 3,
              }

            ],
            id: 'eabc54cb-85e5-4613-a1ff',
            id_nivel1: 'f49d7370-3c3d-4353-828a',
            delete: false,
            name: 'Anphibia', //nombre_cientifico
            name_nivel1: 'Anfibio',
            no_eliminar: true,
            nivel: 2,
          }
        ],
        delete: false,
        id: 'f49d7370-3c3d-4353-828a',
        image: null,
        name: 'Anfibio', //nombre_especie
        nivel: 1,
        no_eliminar: true,
        editable: true,
        url: [
          "",
          ""
        ]
      },
      {
        /*************************************Perro*************************/
        children: [ //Especie
          {},
          {
            children: [ //Nombre cientifico
              {},
              {
                children: [ //Nombre Comun
                  {},
                  { //Raza
                    delete: false,
                    id: '33175d06-707d-4570-857a',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Barbet', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f939011e-a953-427f-a3af',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basenji', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'c3d369a9-7cd4-4be3-b84b',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '3c3a199b-d3b9-4f97-bde2',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset de artois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '45c89ce7-930b-47db-a483',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset de los alpes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6604b009-d683-42d5-97ad',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset de westfalia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '4a4ce6cc-7569-4a32-8043',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset azul de gascuña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '76d173fc-a1ea-41b9-b7ab',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset leonado de bretaña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '42ca738f-b8ff-402f-bc42',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Basset artesiano de normandia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'eae1cda1-51e5-4b26-ab21',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Caniche', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '925a380a-fdf1-4dc3-a60a',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Carlino', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd9573213-646f-44a8-a9eb',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Ca de bou', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '08db08e4-64ba-40f2-a16d',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cane corso', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'a1069bfd-4bbf-473b-a4b8',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cannan dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'da4cf7dd-8f4a-44ce-a382',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Ca de bestiar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '005ad803-322d-4ea9-bcc6',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cairn terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '93b845dc-810f-4a49-b4d3',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de nutrias', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'bdb2ce00-590d-41c2-8da6',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cardigan welsh corgi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd12c4b7d-afac-4fc2-a555',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cao de serra de aires', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '88fcfbab-3070-4a2e-a658',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de alces Sueco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd1a15850-e34a-47bd-8496',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cao de cerra de estrella', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8415',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cao de castro laboreiro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8416',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de osos de carelia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8417',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cavalier king charles spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8418',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de alces noruego gris', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8419',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de nutrias', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8420',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dachshund', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8421',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dalmata almatian', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8422',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dandie dinmont terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8423',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Galgo español', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8424',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Galgo italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8425',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Ganadero australiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8426',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Harrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8427',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Hamilton estovare', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8428',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Havanese havanais', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8429',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Jagdterrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8430',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Japanese chin', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8431',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Japanese terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8432',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Jack rusell terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8433',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kai', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8434',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Landseer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8435',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lakeland terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8436',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Laggoto romagnolo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8437',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Laika ruso europeo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8438',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Laika de ciberia oriental', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8439',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Laika de ciberia oriental', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8440',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Labrador labrador retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8441',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastiff', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8442',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Maremmano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8443',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Magyar agar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8444',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastin inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8445',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastin español', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8446',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Maltes maltese', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8447',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastin tibetano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8448',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastin napolitano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8449',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Malamute de alaska', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8450',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mastin de los pirineos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8451',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Manchester terrier estándar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8452',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Manchester terrier miniatura', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8453',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Papillon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8454',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor aleman', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8454',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor croata', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8456',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor noruego', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8457',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor catalan', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8458',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de karst', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8459',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor holandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8460',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor islandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8461',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de beauce', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8462',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor yugoslavo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8463',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor del atlas', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8464',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor mallorquin', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8465',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de islandia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8466',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de anatolia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8467',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de shetland', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8468',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de caucaso', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8469',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor australiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8470',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de vergamasco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8471',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de brie briard', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8472',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor belga lakenois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8473',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor velga malinois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8474',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor velga tervuren', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8475',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de los pirineos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8476',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de asia central', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8477',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor sueco de laponia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8478',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor belga groenendal', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8479',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor polaco de podhale', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8480',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor jack rusell terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8481',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de rusia meridional', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8482',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor ganadero australiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8483',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor finlandes de laponia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8484',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de la sierra de aires', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8485',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de la sierra estrella', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8486',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor polaco de las llanuras', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8487',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de ricardo pastor de picardie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8488',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de los pirineos de cara pelada', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8489',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor de maremma maremmano abruzzese', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8490',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pastor portugues de la sierra de aires', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1ee373df-4d54-456c-8491',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Rafeiro de alentejo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd4',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Saluki', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd5',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Salchicha', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd6',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sarpraninac', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd7',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso servio', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd8',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso alemán', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-afd9',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso polaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af10',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso tiroles', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af11',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso noruego', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af12',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabuesos suizos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af12',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso español', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af13',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Samoyedo samoyed', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af13',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de hygen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af14',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso helenico', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af15',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso eslovaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af16',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de halden', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af17',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso finlandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af18',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso artesiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af19',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de smaland', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af20',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de schiller', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af21',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de hamilton', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af22',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de posavatz', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af23',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de san humberto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af24',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de transilvania', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af25',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de los valcanes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af26',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso azul de gascuña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af27',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'San bernardo saint bernard', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af28',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso tricolor yugoslavo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af29',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de bosnia pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af30',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de istria pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af31',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de sangre de baviera', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af32',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de istria pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af33',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso de sangre de hannover', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af34',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso tejonero de westfalia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af35',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso austriaco negro y fuego', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af37',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sabueso yugoslavo de la montaña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af38',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'San huberto saint hubert blood hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af39',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Watterhounn weimaraner', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af40',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Ibizan hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af41',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Schipperke', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af41',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Schapendoes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af42',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Schnauzer gigante', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af43',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Scottish deerhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af44',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Schnauzer estandar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af45',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Schnauzer miniatura', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af46',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Scottish terrier scoth terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af47',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Tchuvatch eslovaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af48',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Beagle', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af49',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Beauceron', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af50',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Berger picard', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af51',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bearded collie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af52',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Beagle harrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af53',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bedlington terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af54',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Belgian malinois belgian sheepdog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af55',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bernes de la montaña bernese mountain dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af56',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cesky terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af57',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Deerhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af58',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'German pinscher', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af59',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'German shepherd dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af60',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'German wirehaired pointer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af61',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Germand shorthaired pointer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af62',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kelpie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af63',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Keeshond', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af64',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kerry blue terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af65',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'leobenger', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af66',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lebrel arabe', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af67',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lebrel hungaro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af68',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mexican hairless', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af69',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Newfounland', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af70',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Neapolitan mastiff', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af71',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de artois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af72',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de canaan', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af73',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro salchicha', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af74',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pekines pekingese', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af75',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perdiguero aleman', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af76',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño brabancon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af77',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño perro leon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af78',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de groelandia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af79',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de san humberto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af80',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perdiguero de burtos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af81',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perdiguero de drente', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af82',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perdiguero portugues', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af83',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pembroke welsh corgi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af84',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas frison', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af85',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de los faraones', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af86',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro lobo de saarlos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af87',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro dogo mallorquin', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af88',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro tejonero alpino', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af89',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño sabueso suizo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af90',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño munsterlander', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af91',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas romagna', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af92',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas español', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af93',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro sueco de laponia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af94',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de los visigodos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af95',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de presa canario', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af96',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas irlandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af97',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro lobo checoslovaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af98',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño lebrel italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af99',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño azul de cascuña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5e188931-3bf1-4a0c-af100',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be3',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de aguas portugues', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be4',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de osos de carelia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be5',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de castro laboreiro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be6',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro ganadero australiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be7',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro finlandes de laponia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be8',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño gaston saintngeois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be9',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Petit basset griffon vendeen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be10',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño basset griffon vendeen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be11',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño sabueso azul de gascuña', //raza
                    nname_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be12',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro de presa mallorquin ca de bou', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be13',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro sin pelo de perú pelon peruano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be14',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Perro antiguo de muestra dinamarques', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be15',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pequeño perro holandés para la casa acuatica', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be16',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Redbone coonhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be17',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Setter inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be18',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Setter gordon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be19',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sealyham terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be20',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Segugio italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be21',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Setter irlandés rojo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be22',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Setter irlandés rojo y blanco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be23',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Teckels', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be24',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terranova', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be25',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier gales', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be26',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier japonés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be27',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier escoces', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be28',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier tibetano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be29',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrior irlandés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be30',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier brasileño', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be31',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier ruso negro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be32',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier australiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be33',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier de bedlington', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be34',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier cazador alemán', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be35',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Terrier de la frontera', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be36',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Welsh terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be37',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Wlsh corgi cardigan', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be38',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Welsh corgi pembroke', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be39',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Welsh springer spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be40',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'West highland white terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be41',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Affenpinscher', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be42',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Afgano afchan hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be43',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chow chow', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be44',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chin japonés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be45',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chinese crested', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be46',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chinese shar pei', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be47',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chihuahueño chihuahua', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be48',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chesapeake bay retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be49',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Chart polski lebrel polaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be50',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lhasa apso', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be51',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pharaoh hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be52',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Rhodesian ridgeback rodesiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be53',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Shisoku', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be54',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Shar pei', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be55',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Shih tzu', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be56',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Shiba shiba inu', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be57',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Shetland sheepdog sheltie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be58',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Thai ridgeback', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be59',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Whippet', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be61',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Aidi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be62',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Airedable terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be63',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Billy', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be64',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bichon maltes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be65',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bichon habanero', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be66',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bichon boloñes bolognese', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be67',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bichon frise poil frise bichon pelo rizado', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be68',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cirneco de L-ETNA', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be69',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Field spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be70',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Finnish spitz', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be71',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Fila brasileiro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be72',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Fila de san miguel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be73',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Giant schnauzer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be74',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gigante de los pirineos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be75',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kishu', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be76',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'King charles spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be77',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Miniature pinscher', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be78',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Miniature schnauzer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be79',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Miniature bull terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be80',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pitbull', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be81',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pinscher aleman', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be82',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pincher miniatura', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be83',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Picolo levriero italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be84',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pinscher doberman pinscher', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be85',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pinscher austriaco de pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be86',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Silky terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be87',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Siberian husky', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be88',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Tibetan terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be89',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Tivetan spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be90',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Viejo pastor inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be91',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Viszla de pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be92',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Viszla de pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be93',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Wirehaired pointing griffon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be94',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Akita japonés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be95',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Akita americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be96',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Skye terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be97',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Alaskan malamute', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be98',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Blood hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be99',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Black tan coonhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be100',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Black russian terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be101',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Clumber spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be102',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Elkhound gris', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be103',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Elkhound negro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e52b5207-ebed-4137-9be104',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Flat coated retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8103',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Glen of immal terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8104',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Plott hound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8105',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sloughi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8106',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'American eskimo dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8107',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'American water spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8108',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'American cocker spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8109',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'American staffordshire terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8110',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Smoushond holandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8111',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Anatolian shepherd', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8112',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Antiguo pastor ingles', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8113',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Antiguo pointer danes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8114',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Anglo-francés de caza menor', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8115',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'English setter', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8116',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'English toy spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8117',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'English coocker spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8118',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'English springer spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8119',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Boxer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-81120',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Borzoi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8121',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bobtail', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8122',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Border collie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8123',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Boston terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8124',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Border terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8125',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Boloñes bolognese', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8126',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bouvier de flandres', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8127',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Boubier de appenzell', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8128',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bouvier de entlebuch', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8129',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bouvier de las ardenas', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8130',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Coonhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8131',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Collie barbudo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8132',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Coton de tulear', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8133',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cobrador dorado', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8134',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Collie pelo largo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8135',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Collie pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8136',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cobrador de labrador', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8137',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cobrador de pelo liso', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8138',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Collie de la frontera', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8139',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cocker spaniel inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8140',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Corador de pelo rizado', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8141',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cocker spaniel americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8142',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cobrador de nueva escocia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8143',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Corador de la bahia de chesapeake', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8144',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo aleman', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8145',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo canario', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8146',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo argentino', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8147',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo argentino', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8148',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo del tibet', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8149',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Doberman doberman pinscher', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8150',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Dogo de burdeos dogue des bordeaux', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8151',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Foxhound inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8152',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Fox terrier toy', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8153',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Foxhound americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8154',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Fox terrier pelo duro wire', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8155',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Fox terrier pelo liso smooth', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8156',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gordon setter', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8157',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Golden retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8158',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gos d-atura cerda', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8159',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gos d-atura catala', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8160',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Hovawart', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8161',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Hokkaido', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8162',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Komondor', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8163',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Korea jingo dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8164',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lobero irlandés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8165',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Norwich terrier', //raza
                    name_nivel1: 'Canino',
                    name_nivel2: 'Caninus Lupus',
                    name_nivel3: 'Perro',
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8166',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Norfolk terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8167',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Norrbottenspets', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8168',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Norwegian elkhound grey', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8169',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Norwegian elkhound black', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8170',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Nova scotia duck tolling retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8171',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Poodle', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8172',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Poitevin', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8173',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Porcelana', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8174',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pomeranian', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8175',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cpowder puff', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8176',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Podencio canario', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8178',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Podencio ibicenco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8179',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Poodle estandar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8180',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Podenco portugues', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8181',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Portuguese water dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8182',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pointer inglés pointer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8183',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Polish lowland sheepdog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8184',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pointer aleman de pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8185',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pointer aleman de leo largo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8186',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pointer aleman de pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8187',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pointer griffon de pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8188',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Rottweiler', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8189',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Soft coated wheaten terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8190',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Tosa', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8191',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Toy terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8192',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Toy fox terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8193',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Volpino italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8194',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Xoloitzcuintle estandar', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8195',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Xoloitzcuintle miniatura', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8196',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Xoloitzcuintle intermedio', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8197',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Yorkshire terrier yorkie yorky', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8198',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Epagneul bretton', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-8199',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Epagneul a perdix de drente', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-81100',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spitz aleman', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-81101',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spitz japones', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-81102',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel breton', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ff02ac9a-3812-4673-81105',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spitz finlandes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d8',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel japonés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d9',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel picardo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d10',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel francés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d11',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel de campo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d12',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel tibetano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d13',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spinone italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d14',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spitz de norrbotten', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d15',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Springer spaniel gales', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d16',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel de point audemer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d17',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Springer spaniel inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d18',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel azul de picardia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d19',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Spaniel continental miniatura papillon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d20',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Ariegois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d21',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Briard', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d22',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Broholmer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d23',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Brazo borbones', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d24',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco de dupuy', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d25',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco italiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d26',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco de ariege', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d27',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Brussels griffon', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d28',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco de auvernia', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d29',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco de san german', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d30',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco aleman de pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d31',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco estirio de pelo duro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d32',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco aleman de pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d33',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco francés tipo pirineos', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d34',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco frances blanco y negro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d35',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco eslovaco de pelo corto', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d36',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Briquet griffon dendeen brittany', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d37',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Braco frances tipo gascuña grande', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d38',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Criollo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d39',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Crestado chino', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d40',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Drever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d41',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'French poodle', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d42',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'French poodle', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d43',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'French bulldog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d44',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Frances tricolor', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d45',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Frances blanco y negro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d46',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Frances blanco y anaranjado', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d47',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Greyhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d48',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Great dane', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d49',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran danes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d50',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon belga', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d51',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Great pyrenees', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d52',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon nivernes', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d53',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran boyero suizo', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d54',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran munsterlander', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d55',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran perro japonés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d56',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon de brabante', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d57',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon de bruselas', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d58',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran azul de gascuña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d59',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran griffon vendeen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d60',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon de pelo lanoso', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d61',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran gascon saintogeois', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d62',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Grifon azul de gascuña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d63',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran suizo de la montaña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d64',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Greater swiss mountain dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d65',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Griffon leonado de bretaña', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d66',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran anglo-frances tricolor', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d67',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran basset griffon vendeen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d68',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran anglo-frances blanco y negro', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d69',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Gran anglo-frances blanco y anaranjado', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d70',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Irish setter', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d71',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Irish terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d72',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Irish wolfhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d73',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Irish water spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d74',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kronfohrlander', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d75',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Presa canario', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d76',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Eskimo americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d77',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Osero careliano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d78',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Italian greyhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d79',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Otterhound', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d80',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Stabyhoun', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d81',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Standard schnauzer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d82',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Staffordshire bull terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d83',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Stafordshire terrier americano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d84',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Australian kelpie', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d85',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Australian terrier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d86',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Australian shepherd', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d87',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Australian cattle dog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d88',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bulllmastiff', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d89',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Buhund noruego', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d90',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bulldog francés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bull terrier inglés', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d92',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bulldog ingles bulldog', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d93',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Bull terrier miniatura', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d94',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Curly coated retriever', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d95',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Eurasier', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d96',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Husky siberiano', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d97',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kuvasz', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d98',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Kuvasz eslovaco', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d99',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lundehund noruego', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91a',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Mudi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91b',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Cazador de nutrias', //raza
                    name_nivel1: 'Pug',
                    name_nivel2: 'Caninus Lupus',
                    name_nivel3: 'Perro',
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91c',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Puli', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91d',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pumi', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91e',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Pudelpointer', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91df49f936-5c42-4c1b-a3d91',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Sussex spaniel', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91g',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Azawakh', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'df49f936-5c42-4c1b-a3d91h',
                    id_nivel1: '9a392118-92f6-40f6-9204',
                    id_nivel2: '8cc406fc-0341-4908-a3de',
                    id_nivel3: 'eaeaa598-b5b3-4680-8bbb',
                    name: 'Lowchen', //raza
                    name_nivel1: name_nivel1_canino,
                    name_nivel2: name_nivel2_canino,
                    name_nivel3: name_nivel3_canino,
                    nivel: 4,
                  },

                ],
                delete: false,
                id: 'eaeaa598-b5b3-4680-8bbb',
                id_nivel1: '9a392118-92f6-40f6-9204',
                id_nivel2: '8cc406fc-0341-4908-a3de',
                name: 'Perro', //nombre_comun
                name_nivel1: 'Canino',
                name_nivel2: 'Caninus Lupus',
                no_eliminar: true,
                nivel: 3,
              }

            ],
            id: '8cc406fc-0341-4908-a3de',
            id_nivel1: '9a392118-92f6-40f6-9204',
            delete: false,
            name: 'Caninus Lupus', //nombre_cientifico
            name_nivel1: 'Canino',
            no_eliminar: true,
            nivel: 2,
          }
        ],
        delete: false,
        id: '9a392118-92f6-40f6-9204',
        image: null,
        name: 'Canino', //nombre_especie
        nivel: 1,
        no_eliminar: true,
        url: [
          url_canino,
          ""
        ]
      },
      {
        /************************* Gato ***************************/
        children: [ //Especie
          {},
          {
            children: [ //Nombre cientifico
              {},
              {
                children: [ //Nombre Comun
                  {},
                  { //Raza
                    delete: false,
                    id: '9842e114-f7d5-49eb-a34c',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Balines', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9343ed2e-b23a-404f-8c28',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Café havana', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7b205657-b2b5-4f6b-b883',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Javanes', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1bd9f6ef-8464-4231-9e77',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Japones de cola corta', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'c205d6e9-a605-4cfb-a69b',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Manx', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'c018d81e-7658-494c-b599',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Maine coon', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9a730ea5-2089-41d5-93ae',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Mau egipcio', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f4dcbc50-9088-46cc-af43',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Ragdoll', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'da343af9-6ef9-4655-9ee4',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Van turco', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd9d53732-25d6-4822-9229',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Abisinio', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'a284548e-b155-4151-8bac',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Ocicat', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b744bf5f-b31a-4e1f-baea',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Bengali', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5ee776c8-aad4-44b3-8972',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Mexicano doméstico', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '629a18ba-02eb-4cae-9cd8',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Persa', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '30b815e3-aa50-4a4e-b7f2',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Rex', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f13303e5-aefb-4ccd-9fad',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Rex devon', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '2753ff7d-c198-4ade-bb15',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Rex cornico', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '024c0a37-cec9-4bfe-af8c',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Chartreux', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7ebdf07f-9eaa-48ca-ba99',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Birmano', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '90796506-266b-413a-9619',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Himalaya', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '31f0f8f6-acdd-4719-8886',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Siames', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'c21f4bc1-9a3f-4feb-8831',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'American curl', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '0d973d2f-3dd9-4bda-809d',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Americano de pelo corto', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '63f9417c-6151-4d18-bdd8',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Angora', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7d9ed235-3e9e-408d-b988',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Angora turco', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '083bc325-8db6-454b-a62b',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Bombay', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '36bbfea6-19ba-4e58-a04d',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Korat', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7843c654-b69c-4acc-9850',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Noruego del bosque', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '362a250f-d9b1-4394-9deb',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Somali', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ac4ce17d-4363-40d6-b3a0',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Tonkines', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'aa037693-aeb0-4050-b2fb',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Britanico de pelo corto', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '8f0aa44a-8b4c-4653-83c7',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Oriental', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '54065b66-03bd-413b-92fd',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Esfinge', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'c9316acd-538a-4aaa-b437',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Escoces de oreja caida', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '4737a9fd-ea9a-4210-981b',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Burmes', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e817fb10-27ba-4290-b7cc',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Europeo de pelo corto', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '032c764f-fe9e-4687-a28f',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Exotico de pelo corto', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1971d389-b9b5-4285-afb6',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Cymric', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6a07af72-65d6-41a4-96c4',
                    id_nivel1: '9a393718-92f6-40f6-9444',
                    id_nivel2: '8cc976fc-0341-4908-a3de',
                    id_nivel3: 'eae66598-b5b3-4680-8bbb',
                    name: 'Azul ruso', //raza
                    name_nivel1: name_nivel1_felino,
                    name_nivel2: name_nivel2_felino,
                    name_nivel3: name_nivel3_felino,
                    nivel: 4,
                  },
                ],
                delete: false,
                id: 'eae66598-b5b3-4680-8bbb',
                id_nivel1: '9a393718-92f6-40f6-9444',
                id_nivel2: '8cc976fc-0341-4908-a3de',
                name: 'Gato', //nombre_comun
                name_nivel1: 'Felino',
                name_nivel2: 'Minino Lupus',
                no_eliminar: true,
                nivel: 3,
              }

            ],
            id: '8cc976fc-0341-4908-a3de',
            id_nivel1: '9a393718-92f6-40f6-9444',
            delete: false,
            name: 'Minino Lupus', //nombre_cientifico
            name_nivel1: 'Felino',
            no_eliminar: true,
            nivel: 2,
          }
        ],
        delete: false,
        id: '9a393718-92f6-40f6-9444',
        image: null,
        name: 'Felino', //nombre_especie
        nivel: 1,
        no_eliminar: true,
        url: [
          url_felino,
          ""
        ]
      },
      {
        /*************************Equino*************************/
        children: [ //Especie
          {},
          {
            children: [ //Nombre cientifico
              {},
              {
                children: [ //Nombre Comun
                  {},
                  { //Raza
                    delete: false,
                    id: '1631ab0b-e072-4bc2-a2c2',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Bavaro', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b6c9da76-a1d4-4e6a-bd50',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Caspio', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9871d628-dcc0-4cf1-818e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Camargues', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '033d1ff7-552d-4790-9d9a',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Dales', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd00ee43e-d8f9-4bc2-a439',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Dartmoor', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '77929411-5303-453a-b684',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Falabella', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '21077946-9aa2-48e9-974f',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Hackney', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ec87f209-2b30-4bb9-bda0',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Haflinger', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '4b8ae952-e998-46a4-babf',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Hannoveriano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'a8ad1245-3194-4916-85da',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Karabakh', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6c0221e4-b8b5-4cc9-847a',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Karabair', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e439a878-13f8-4848-8a56',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Karabardin', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7fdaa1c6-524d-4577-8874',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Mallorquin', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '56f794ea-d819-4870-8b4e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Palomino', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e79d2b02-b82f-4493-8d87',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Paso fino', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '474f9901-8819-49d1-ae9c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Paso de tennesse', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1bf92971-d7b7-4ece-b678',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Salernitano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '55bb4fed-bb6b-4925-a7bc',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tarpan', //raza
                    name_nivel1: 'Equino',
                    name_nivel2: 'Equino',
                    name_nivel3: 'Caballo',
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '2e618904-680b-433a-8054',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Waler', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6bd5604c-1f27-417f-95f9',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Waler australiano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '33eafd15-9703-486d-b240',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Bereber', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5aecbe71-a257-49db-accb',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Berberisco', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '630c8948-284f-48e2-a8aa',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Fell', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '84a31087-5010-4a5e-b24c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Gelderland', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5aad8c4b-e502-41ed-bef1',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Menorquina', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f171e4bd-fc6e-4e40-bb1c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Peruano de paso', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6adf373a-451f-4179-8119',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Percheron francés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '8e781309-621c-4245-b544',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tersk', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'a098b369-4258-49d0-9fc2',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Westfaliano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '0eedd2eb-7f08-4fb5-b41e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Shire', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '00462a26-9b35-42b4-8f60',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Shagya', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '0eff0580-0cac-4ade-bba4',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Lipizzano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9e7a9cea-504c-46aa-8e7e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Pinto', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'fcbfce63-930f-4caa-aec5',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Silla francés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ee420ae5-d2d7-4485-bc86',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Silla italiano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ccf52e41-b22f-4c48-866d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Silla americano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6fa3607d-0220-47d8-989b',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tiro danes', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '22706177-eb45-431c-ad41',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tiro holandés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '8eb014e6-7f31-4071-916d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tiro irlandés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '2c8ca38d-6c26-4e7d-b212',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tiro de schleswig', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9f232500-6699-4b7a-9a73',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Tiro pesado del rin', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '46a11f03-9f2c-4c2d-b7f8',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Viatka', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6c2d99c2-e34c-4bea-a655',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Wielkopolski', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ad0ca8a2-7483-47a2-9add',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Fjord', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7c7b8550-3a98-45b6-b1c5',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Akhal teke', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '549b5262-383c-4a75-9f7c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Albino', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5eb836da-afb8-4984-91f7',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Alter real', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e4329a13-e0d9-4b2b-910d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Clydesdale', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'd5b81fb1-4b08-4ab5-a4a7',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cleveland bay', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9e3b5b47-7775-482b-8c1f',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Kladruber', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '03c069cf-bfa2-474e-b36b',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Olndenburgo', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'bc67220b-bdde-484e-b1c7',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Bladimir', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '6b80c5a8-558f-4443-aa27',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Andaluz', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '5fc8794d-5318-42b9-9eb2',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Boloñez', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '3d354104-722e-4e1d-a759',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Comtois', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '676e4821-981b-4a37-855d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cob gales', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'dc532e97-e42c-4200-b938',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Connemara', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'cfd0f8cb-70d9-4f93-bb54',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Dole', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '72012275-c779-4308-81a5',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Fox trotter misouri', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '716d1541-20e8-4cdd-8c3e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Gotland', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'cafab918-d446-4ba9-bc4c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Holstien', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'fbcc7157-a9f1-4a7b-bbfd',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Holandes sangre caliente', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '19a58950-4069-49fd-83a1',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Mongol', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '419f7463-f83c-4384-8925',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Morgan hourse', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '43341b3d-d9db-4f6d-8c9c',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Nonius', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '1fba6625-fa04-41fe-b56e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Noriker', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'bb1edb59-c7f6-40ba-82de',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Poni gales', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '62596a49-fab5-4974-9654',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Poni americano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '8fa65009-1df7-494f-b303',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Poni pintado ingles', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '374534be-aaf4-4475-b992',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Poni de silla ingles', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e472b2eb-428c-4904-9b5b',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Sorraia', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '7e9c052c-c247-4ac2-a12f',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Toric', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '0151b0ae-7906-4bfe-8806',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Appaloosa', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '3a0f1d1d-eb28-4dd7-b82e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Ardenes', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '34095d24-efb8-4952-b0bc',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Breton', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'e68fde4a-c2a2-4fd3-8646',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Brumby', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b2bb4387-14e8-45aa-b7d1',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Brabante', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '30f85b2e-9b26-418d-b60f',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Criollo', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '2d1822cb-22fc-455c-a296',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cruzado americano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '25e78934-d2ae-4238-9c7e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cruzado argentino', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '92106e93-9f09-4e8f-9839',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Frison', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f1e2dded-1ad1-4667-8c51',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Freiberger', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'eef005c9-9e9d-424f-9e92',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Frederiksborg', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '457d67c0-d5cb-40af-9e9d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Groningen', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '48403fa3-b914-4753-8e83',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Trakhner', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '616dec84-c35e-4819-b15d',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Troton francés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'ebba6548-3364-41eb-8547',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Troton de orlov', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b0fc0d11-9ac3-40bf-b697',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Asturcon', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '986bd7b0-fa1e-4e0f-8668',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Buckskin', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '9a030ce2-5843-4d7a-9693',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Buyonny', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b364cc57-ef5f-42fc-a24a',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cuarto de milla americano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '258f7729-0424-45ad-9d92',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Cuarto de milla canadiense', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '420bf0d5-140c-49f6-b2b0',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Hungaro', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f821f981-b61e-4564-ad99',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Hunter irlandés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '99749f86-6c20-4dda-a2b7',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'lusitano', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '46230e2d-8362-448f-959a',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Mustang', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'cfc4ac29-c018-4482-9653',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Pura sangre árabe', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'f62fc3ab-c0cb-49a0-b69f',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Pura sangre española', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'bb2a52e7-b3d9-4782-b04e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Pura sangre inglés', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '27423976-d829-4ab4-975e',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Pura sangre angloarabe', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b492857d-8a9e-4986-8029',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Sueco del norte', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: '19b2870b-365d-42de-a3ff',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Sueco sangre caliente', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'b693be21-37ab-4c69-a482',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Aveliñes', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },
                  { //Raza
                    delete: false,
                    id: 'cb6ed4e5-31d6-499b-9803',
                    id_nivel1: '6d39f518-f55a-4b8b-acff',
                    id_nivel2: '66cea50b-caf6-4545-9ed4',
                    id_nivel3: 'e5d84ff1-148a-4990-ad9c',
                    name: 'Azteca', //raza
                    name_nivel1: name_nivel1_equino,
                    name_nivel2: name_nivel2_equino,
                    name_nivel3: name_nivel3_equino,
                    nivel: 4,
                  },

                ],
                delete: false,
                id: 'e5d84ff1-148a-4990-ad9c',
                id_nivel1: '6d39f518-f55a-4b8b-acff',
                id_nivel2: '66cea50b-caf6-4545-9ed4',
                name: 'Caballo', //nombre_comun
                name_nivel1: 'Equino',
                name_nivel2: 'Equino',
                no_eliminar: true,
                nivel: 3,
              }

            ],
            id: '66cea50b-caf6-4545-9ed4',
            id_nivel1: '6d39f518-f55a-4b8b-acff',
            delete: false,
            name: 'Equino', //nombre_cientifico
            name_nivel1: 'Equino',
            no_eliminar: true,
            nivel: 2,
          }
        ],
        delete: false,
        id: '6d39f518-f55a-4b8b-acff',
        image: null,
        name: 'Equino', //nombre_especie
        nivel: 1,
        no_eliminar: true,
        url: [
          url_equino,
          ""
        ]
      },
      {
        /****************** Huron ***************/
        children: [ //Especie
          {},
          {
            children: [ //Nombre cientifico
              {},
              {
                children: [ //Nombre Comun
                  {},
                  { //Raza
                    delete: false,
                    id: 'c2145e6d-c310-4ff0-9cc1',
                    id_nivel1: '9e5f35be-8518-43b3-9c40',
                    id_nivel2: '30fdad47-db76-4814-96ce',
                    id_nivel3: '45f15deb-c9a1-4a04-bccb',
                    name: 'Hurón', //raza
                    name_nivel1: 'Mustelido',
                    name_nivel2: 'Mustelidae',
                    name_nivel3: 'Hurón',
                    nivel: 4,
                  }

                ],
                delete: false,
                id: '45f15deb-c9a1-4a04-bccb',
                id_nivel1: '9e5f35be-8518-43b3-9c40',
                id_nivel2: '30fdad47-db76-4814-96ce',
                name: 'Hurón', //nombre_comun
                name_nivel1: 'Mustelido',
                name_nivel2: 'Mustelidae',
                no_eliminar: true,
                nivel: 3,
              }

            ],
            id: '30fdad47-db76-4814-96ce',
            id_nivel1: '9e5f35be-8518-43b3-9c40',
            delete: false,
            name: 'Mustelidae', //nombre_cientifico
            name_nivel1: 'Mustelido',
            no_eliminar: true,
            nivel: 2,
          }
        ],
        delete: false,
        id: '9e5f35be-8518-43b3-9c40',
        image: null,
        name: 'Mustelido', //nombre_especie
        nivel: 1,
        no_eliminar: true,
        editable: true,
        url: [
          "",
          ""
        ]
      },

    ],
    name: "Especies",
  }
}

export const DATA_BASE_OBJ = {
  nivel: 0,
  nombre: "",
  nombreEspecieSelect: '',
  nombreCientificoSelect: '',
  nombreComunSelect: '',
  nombreRazaSelect: '',
  idNombreEspecieSelect: '',
  idNombreCientificoSelect: '',
  idNombreComunSelect: '',
  idNombreRazaSelect: '',
  url: '',
  es_editable: false,
}

export const OPCIONES_FILTRO_BASE_OBJ = [{
    value: 'especie',
    text: 'Especie'
  },
  {
    value: 'nombre_cientifico',
    text: 'Nombre científico'
  },
  {
    value: 'nombre_comun',
    text: 'Nombre común'
  },
  {
    value: 'razas',
    text: 'Razas'
  },
]



// WEBPACK FOOTER //
// ./src/constantes/especies.js